export const getSelectDefaultValue = (value: number | null | undefined): number | string | undefined => {
    return value !== null ? value : undefined;
};